module.exports = __webpack_public_path__ + "static/media/dish_card4.4d76545a.png";